// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

if (process.env.NODE_ENV === "production") {
  Bugsnag.start({
    apiKey: "88b698e2f1ce09e9324b8e44f26e7f4a",
    appVersion: process.env.VUE_APP_GIT_HASH,
    plugins: [new BugsnagPluginVue()]
  });
  const bugsnagVue = Bugsnag.getPlugin("vue");
  bugsnagVue.installVueErrorHandler(Vue);
}

import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import * as Config from "./config";

import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import Tippy from "v-tippy";
import VueProgressiveImage from "vue-progressive-image";
import linkify from "vue-linkify";
import { CalendarHeatmap } from "vue-calendar-heatmap";
Vue.directive("linkified", linkify);

import "./filters";

import PortalVue from "portal-vue";

Vue.use(PortalVue);
Vue.use(VueSweetalert2);
Vue.use(Tippy);
Vue.use(VueProgressiveImage);
Vue.component("v-select", vSelect);
Vue.component("calendarHeatmap", CalendarHeatmap);

// include styles for plugins
import "sweetalert2/dist/sweetalert2.min.css";
import "v-tippy/dist/tippy.css";
import "vue-select/dist/vue-select.css";

const token = localStorage.getItem("access_token");
console.log("token", token);
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}
axios.interceptors.response.use(null, error => {
  if (error.response.status == 401) {
    store.commit("auth/clearAccessToken");
    localStorage.removeItem("access_token");
    router.push({ path: "/login" });
  }
  return Promise.reject(error);
});

Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.prototype.$eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
